import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { FileUploadModule } from 'ng2-file-upload';

import { UsuarioEmailAssinaturaUploadComponent } from './usuario-email-assinatura-upload.component';

@NgModule({
    imports: [
        SharedModule,
        FileUploadModule
    ],
    declarations: [
        UsuarioEmailAssinaturaUploadComponent
    ],
    exports: [
        UsuarioEmailAssinaturaUploadComponent
    ]
})
export class UsuarioEmailAssinaturaUploadModule { }
